"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.globalLogout = void 0;
const getDomain_1 = require("./getDomain");
const globalLogout = () => {
    const exp = ' expires=Thu, 01 Jan 1970 00:00:00 UTC;';
    document.cookie = `userToken=;  ${exp}; path=/`;
    document.cookie = `catalogCreated=;  ${exp}; path=/`;
    document.cookie = `businessunit=;  ${exp}; path=/`;
    document.cookie = `userToken=;  ${exp}; path=/perfil`;
    document.cookie = `catalogCreated=;  ${exp}; path=/perfil`;
    document.cookie = `businessunit=;  ${exp}; path=/perfil`;
    const domain = (0, getDomain_1.getDomain)();
    document.cookie = `tokenAutorizacao=;  ${exp} domain=${domain}; path=/perfil`;
    document.cookie = `tokenValidade=;  ${exp} domain=${domain}; path=/perfil`;
    document.cookie = `tokenRenovacao=;  ${exp} domain=${domain}; path=/perfil`;
    document.cookie = `identificador=;  ${exp} domain=${domain}; path=/perfil`;
    document.cookie = `tokenAutorizacao=;  ${exp} domain=${domain}; path=/`;
    document.cookie = `tokenValidade=;  ${exp} domain=${domain}; path=/`;
    document.cookie = `tokenRenovacao=;  ${exp} domain=${domain}; path=/`;
    document.cookie = `identificador=;  ${exp} domain=${domain}; path=/`;
    localStorage.removeItem('re');
};
exports.globalLogout = globalLogout;
